<template>
  <b-layout :colors="$site.colors" :header-title="$t('pages.gift.pass.claim.title')">
    <b-container class="mt-12">
      <b-summary>
        <template #summary>
          <b-card class="text-secondary">
            <img v-if="customerPass.gift && passImage" :src="passImage" class="mb-4 rounded">

            <div v-if="customerPass.gift.to" class="mb-1">
              <strong>{{ customerPass.gift.to.name }},</strong>
            </div>
            <div v-if="customerPass.gift.message">
              {{ customerPass.gift.message }}
            </div>
            <div v-if="customerPass.gift.from" class="mt-3">
              <strong>{{ customerPass.gift.from.name }}</strong>
            </div>
            <hr>
            <h3 class="font-semibold text-xl mt-6 mb-6">
              {{ customerPass.pass.name }}
            </h3>
            <h6 class="text-xs font-weight-light mb-2">
              {{ $site.location.title }}
            </h6>
          </b-card>
        </template>

        <div>
          <template v-if="!selectedCustomer">
            <b-alert v-if="customerPass.gift.to && customerPass.gift.from" show variant="warning">
              <h4 class="alert-heading" v-html="$t('pages.gift.pass.claim.luckyYouName',{name: customerPass.gift.to.name})" />
              <p v-html="$t('pages.gift.pass.claim.hasGivenYouAGift',{from: customerPass.gift.from.name, passName: customerPass.pass.name, location: $site.location.title})" />
              <p v-html="$t('pages.gift.pass.claim.provideEmail',{passName: customerPass.pass.name})" />
            </b-alert>

            <customer-select :title="$t('pages.gift.pass.claim.yourDetails')" @selected="select" />
          </template>

          <b-errors :errors="errors" />

          <template v-if="selectedCustomer">
            <b-card :title="$t('pages.gift.pass.claim.claim')" class="mb-4 ">
              <p class="mb-4" v-html="$t('pages.gift.pass.claim.title',{passName: customerPass.pass.name, location: $site.location.title})" />

              <strong>{{ $t('general.name') }}:</strong> {{ selectedCustomer.displayName }}<br>
              <strong>{{ $t('general.email') }}:</strong> {{ selectedCustomer.email }}

              <b-button
                type="submit"
                class="w-full"
                variant="action"
                :loading="claiming"
                :disabled="claiming"
                @click="claim"
              >
                {{ $t('pages.gift.pass.claim.claimPass',{passName: customerPass.pass.name}) }} »
              </b-button>
            </b-card>
          </template>
        </div>
      </b-summary>
    </b-container>
  </b-layout>
</template>

<script>
import CustomerSelect from '@/components/customer/elements/Select.vue'

definePageMeta({
  tabs: ['giftCard']
});

export default defineNuxtComponent({
  components: {
    CustomerSelect
  },
  async asyncData () {
    const route = useRoute()
    const { $api } = useNuxtApp()
    const query = route.query

    if (query.id) {
      const response = await $api.pass.customerPass(query.id, query.signature)
      let customerPass = null

      if (response.success && response.customerPass) {
        customerPass = response.customerPass

        if (!customerPass.claimable) {
          navigateTo({ path: '/customer/pass', query: { id: query.id, signature: query.signature } })
        }

        return {
          customerPass
        }
      }
    }
  },
  data () {
    return {
      selectedCustomer: null,
      claiming: false,
      errors: null
    }
  },
  computed: {
    passImage () {
      if (this.customerPass.pass.images) {
        return this.customerPass.pass.images.large
      } else if (this.$site.images.pass) {
        return this.$site.images.pass.large
      }
      return null
    }
  },
  methods: {
    select ({ customer }) {
      this.selectedCustomer = customer
    },
    async claim () {
      this.claiming = true

      const query = this.$route.query
      const response = await this.$api.pass.claim(query.id, query.signature, this.selectedCustomer, query.claim)
      if (response.errors) {
        this.errors = response.errors
      } else if (response.success) {
        this.$router.push({ path: '/customer/pass', query: { id: query.id, signature: query.signature } })
      } else {
        this.errors = ['There was an error claiming the pass']
      }

      this.claiming = false
    }
  }
})
</script>
